
import React, { Fragment } from 'react'

export const AppEventDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>AppEvent 操作事件</h1>    
    </div>)
}


// WEBPACK FOOTER //
// ./src/modules/Demo/components/platform/AppEventDemo.tsx